module.exports = __webpack_public_path__ + "img/mon.b2a2fc77.jpg";